import axios from 'axios';
const BASE = 'https://fitnesstrac-kr.herokuapp.com/api';

export default async function GetAllPublicRoutinesByUser({user, token}){

    try {
      const response = await axios.get(`${BASE}/users/${user.username}/routines`, {
        headers: { 'Content-Type' : 'application/json',
            'Authorization': `Bearer ${token}`}
      })
      
      return {response}
      
      
      
      
    } catch (error) {
      console.error(error);
    } 
}